import { DropDown, Input, ModalMsgControl } from '../controls';
import { DataContext } from '../../data/DataContext';
import { useContext, useEffect, useState } from 'react';
import http from '../../../../services/http'
import { endPoints } from '../../../../utils/constanst'
import { vehicleStatus } from '../../data/MochaData';

import { propMsg } from '../../data/Help';

const Step2 = () => {

    const { AutoHN, setAutoHN, changeHandler } = useContext(DataContext);
    const [propModalMsg, setPropModalMsg] = useState(propMsg);

    const onChangeCbo = (property: string, value: string) => {
        setAutoHN({ ...AutoHN, [property]: value });      
    }

    useEffect(() => {
        if (AutoHN.vehicleBrand !== '' && AutoHN.vehicleBrand !== undefined) {
            setPropModalMsg({ ...propModalMsg, active: true });
            http(endPoints.models(AutoHN.idPlan, AutoHN.vehicleBrand)).get()
                .then(result => {
                    setAutoHN({ ...AutoHN, catVehicleModel: result, isDatasheet: false});
                })
                .finally(() => (setPropModalMsg({ ...propModalMsg, active: false })));
        }
    }, [AutoHN.vehicleBrand]);

    useEffect(() => {
        if (AutoHN.vehicleModel !== '' && AutoHN.vehicleModel !== undefined && AutoHN.vehicleBrand !== '' && AutoHN.vehicleBrand !== undefined) {
            setPropModalMsg({ ...propModalMsg, active: true });
            http(endPoints.lastYear(AutoHN.idPlan, AutoHN.vehicleBrand, AutoHN.vehicleModel)).get()
                .then(result => {
                    setAutoHN({ ...AutoHN, catVehicleYear: result, isDatasheet: false});
                })
                .finally(() => (setPropModalMsg({ ...propModalMsg, active: false })));
        }
    }, [AutoHN.vehicleModel])

    return (
        <>
            <DropDown
                label='Uso del vehículo*'
                dataProvider={AutoHN.catVehicleUse.filter( (x:any) => x.value === '1')}
                valueSelect={AutoHN.vehicleUse}
                field='vehicleUse'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona'
            />
            <DropDown
                label='Estado del vehículo*'
                dataProvider={vehicleStatus}
                valueSelect={AutoHN.vehicleStatus}
                field='vehicleStatus'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona'
            />
            <DropDown
                label='Marca*'
                dataProvider={AutoHN.catVehicleBrand}
                valueSelect={AutoHN.vehicleBrand}
                field='vehicleBrand'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona'

            />
            <DropDown
                label='Modelo*'
                dataProvider={AutoHN.catVehicleModel}
                valueSelect={AutoHN.vehicleModel}
                field='vehicleModel'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona'
                hasDescription={true}
            />
            <DropDown
                label='Año*'
                dataProvider={AutoHN.catVehicleYear}
                valueSelect={AutoHN.vehicleYear}
                field='vehicleYear'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona'

            />
            <Input
                id='vehicleChassis'
                label='Chasis*'
                onlyInput
                value={'0'}
                field='vehicleChassis'
                onChange={changeHandler}
                placeholder="Ingrese el chasis"
                cssClassStyle="hidden"
            />
            <Input
                id='vehicleValue'
                label='Valor del vehículo*'
                value={AutoHN.vehicleValue}
                field='vehicleValue'
                onChange={changeHandler}
                placeholder="L 00.00"
                type='number'
                useToolTip={true}
                textToolTip='Es el monto máximo de dinero en Lempiras que se contempla para los incidentes cubiertos por cada cobertura.'
                titleToolTip='Valor del vehículo'
                //isReadOnly ={ AutoHN.vehicleStatus === '0' ? true : false}
            />
           

            <ModalMsgControl
                active={propModalMsg.active}
                txtMsg={propModalMsg.txtMsg}
                closeModal={propModalMsg.closeModal}
            />
        </>
    );
}

export { Step2 }